// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoBlock_wrapper__kur_b","videoBlockContainer":"VideoBlock_videoBlockContainer__EKkJW"};